export type AudioCallbacks = {
  onStart?: () => void
  onEnded?: () => void
  onError?: () => void
  onStop?: () => void
}

let activeAudio: HTMLAudioElement | null = null
let activeCallbacks: AudioCallbacks | null = null

export function playAudio(audioPath: string, callbacks?: AudioCallbacks) {
  if (typeof window === 'undefined' || typeof Audio === 'undefined') return

  stopAudio()

  try {
    const audio = new Audio(audioPath)
    activeAudio = audio
    activeCallbacks = callbacks || null

    callbacks?.onStart?.()

    const handleEnded = () => {
      if (activeAudio === audio) {
        activeAudio = null
        activeCallbacks = null
      }
      callbacks?.onEnded?.()
    }

    const handleError = () => {
      if (activeAudio === audio) {
        activeAudio = null
        activeCallbacks = null
      }
      callbacks?.onError?.()
    }

    audio.addEventListener('ended', handleEnded, { once: true })
    audio.addEventListener('error', handleError, { once: true })

    void audio.play().catch((err) => {
      console.error('Audio play failed:', err)
      handleError()
    })
  } catch (error) {
    console.error('Audio initialization failed:', error)
    callbacks?.onError?.()
  }
}

export function stopAudio() {
  if (typeof window === 'undefined') return

  if (activeAudio) {
    try {
      activeAudio.pause()
      activeAudio.currentTime = 0
    } catch (err) {
      console.error('Failed to pause or reset active audio:', err)
    }
    activeAudio = null
  }
  if (activeCallbacks?.onStop) {
    try {
      activeCallbacks.onStop()
    } catch (err) {
      console.error('Failed to invoke onStop callback:', err)
    }
  }
  activeCallbacks = null
}

